import { createSlice } from "@reduxjs/toolkit";

const checkInCheckOutSlice = createSlice({
  name: "checkInCheckOut",
  initialState: {
    attendee: null,
    count: 0,
  },
  reducers: {
    setAttendee: (state, action) => {
      state.attendee = action.payload.attendee;
      state.count = action.payload.count;
    },
    increaseCounter: (state, action) => {
      state.count = state.count + 1;
    },
  },
});

export const { setAttendee, increaseCounter } = checkInCheckOutSlice.actions;

export default checkInCheckOutSlice.reducer;
